export * from "./AcceptForm";
export { default } from "./AcceptForm";
